import { create } from 'zustand';
import { OrganizationSettingsInterface } from '../interfaces/organizationSettings.interface';

interface OrganizationSettingsState {
  organizationSettings: OrganizationSettingsInterface,
  setOrganizationSettings: (_newOrganizationSettings: OrganizationSettingsInterface) => void,
  setOnboardingFinished: (_onboardingFinished: boolean) => void,
}

interface OrganizationState {
  selectedOrganization: any,
  setSelectedOrganization: (_newOrganizationSettings: any) => void,
}
export const useOrganizationSettingsStore = create<OrganizationSettingsState>((set) => ({
  organizationSettings: {
    isSnapchatActive: false,
    finalUrlSuffixUpdatedAt: new Date().toISOString(),
  },
  setOrganizationSettings: (newOrganizationSettings) => set(() => ({
    organizationSettings: newOrganizationSettings,
  })),
  setOnboardingFinished: (onboardingFinished) => set((state) => ({
    organizationSettings: {
      ...state.organizationSettings,
      onboardingFinished,
    },
  })),
}));

export const useOrganizationStore = create<OrganizationState>((set) => ({
  selectedOrganization: null,
  setSelectedOrganization: (organization) => set({ selectedOrganization: organization }),
}));
